import * as React from 'react';
import { connect } from 'react-redux';

import { withModal } from 'components/modal/ModalHOC';
import ActionButton from 'components/buttons/action-button/ActionButton';

import ListsCreateEditModal from './ListsCreateEditModal';

import { t } from 'utils/language';

type StateProps = {
  currentOrganizationId: number
};

type OwnProps = {
  onAddList: () => void
};

type Props = StateProps & OwnProps;

const ActionButtonWithModal = withModal(ActionButton, {
  modalContent: ListsCreateEditModal
});

class ListDashboardAddListButton extends React.Component<Props> {
  render() {
    const { currentOrganizationId, onAddList } = this.props;
    return (
      <ActionButtonWithModal
        modalContentProps={{
          title: t('lists.modal_title_create'),
          organizationId: currentOrganizationId,
          onSave: onAddList
        }}
        color="secondary"
        size="medium"
        transform="uppercase"
      >
        + {t('lists.dashboard.buttons.add_list')}
      </ActionButtonWithModal>
    );
  }
}

const mapStateToProps = ({ organizations: { currentOrganization: { id } } }): StateProps => ({
  currentOrganizationId: id
});

export default connect(mapStateToProps)(ListDashboardAddListButton);
